import { motion } from "framer-motion";

function FilterCard({ filter, selected, onClick, loading, isActive }) {
  return (
    <motion.button
      whileHover={loading || !isActive ? {} : { y: -6, scale: 1.03 }}
      whileTap={loading || !isActive ? {} : { scale: 0.985 }}
      onClick={loading || !isActive ? undefined : onClick}
      className={`relative rounded-2xl text-left shadow-sm transition-all duration-300 focus:outline-none ring-1 bg-white/95 w-full ${
        loading ? "opacity-60 cursor-not-allowed" : ""
      } ${
        !isActive && !loading ? "opacity-60 cursor-not-allowed" : "cursor-pointer hover:shadow-xl"
      } ` +
        (selected ? "ring-2 ring-emerald-500" : isActive ? "ring-gray-200 hover:ring-emerald-400" : "ring-gray-200")}
    >
      <div className="p-3 w-full max-w-[12rem] mx-auto">
        <div className="relative w-full aspect-square">
          <img 
            src={filter.image} 
            alt={filter.title} 
            className={`object-contain absolute inset-0 w-full h-full transition-all duration-300 ${
              loading ? "opacity-50" : !isActive ? "opacity-40 grayscale" : "opacity-100"
            }`} 
          />
          {loading && (
            <div className="flex absolute inset-0 justify-center items-center">
              <div className="w-6 h-6 rounded-full border-b-2 border-emerald-500 animate-spin"></div>
            </div>
          )}
        </div>
        <div className="px-1 mt-2 text-center">
          <p className={`text-sm font-semibold leading-snug transition-colors duration-300 ${
            loading ? "text-gray-500" : "text-gray-900"
          }`}>
            {filter.title}
          </p>
          {loading && (
            <p className="mt-1 text-xs text-emerald-600">Loading...</p>
          )}
          {!isActive && !loading && (
            <div className="inline-flex items-center px-2 py-1 mt-2 text-xs font-medium text-orange-800 bg-orange-100 rounded-full border border-orange-200">
              <span className="w-1.5 h-1.5 bg-orange-400 rounded-full mr-1.5 animate-pulse"></span>
              Coming Soon
            </div>
          )}
        </div>
      </div>
    </motion.button>
  );
}

export default function PrimaryFilters({ filters, selectedKey, onSelect, loading }) {
  return (
    <div className="grid grid-cols-1 gap-5 place-items-center sm:grid-cols-2 lg:grid-cols-3">
      {filters.map((filter) => (
        <FilterCard
          key={filter.key}
          filter={filter}
          selected={selectedKey === filter.key}
          onClick={() => onSelect(filter.key)}
          loading={loading}
          isActive={filter.isActive}
        />
      ))}
    </div>
  );
}

